<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> 1.1
  </div>
  <strong>Copyright &copy; 2024 AdminExchange</strong> 
</footer>
